module.exports = __webpack_public_path__ + "static/media/AfghanMan.632e1c39.svg";